/**
 * Labstep
 *
 * @module components/OrderRequestTemplate/Action/Delete
 * @desc Action to delete
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { OrderRequestTemplateActionDeleteProps } from './types';

export const OrderRequestTemplateActionDelete: React.FC<
  OrderRequestTemplateActionDeleteProps
> = ({ orderRequestTemplate }) => (
  <EntityActionDelete
    entity={orderRequestTemplate}
    actionComponentProps={{
      type: 'button',
      text: orderRequestTemplate.deleted_at
        ? 'Enable Template'
        : 'Disable Template',
    }}
    skipConfirmation
  />
);
